import { addAlert } from '../../../../MsgNotify/msgNotifyActions';
import { httpGet } from '../../../../Util/http';



export const GET_WORKPLACE_ACTIVITYFEEDS_REQUEST = 'GET_WORKPLACE_ACTIVITYFEEDS_REQUEST';
export const getWorkplaceActivityFeedsRequest = () => (
    {
        type: GET_WORKPLACE_ACTIVITYFEEDS_REQUEST
    }
)


export const GET_WORKPLACE_ACTIVITYFEEDS_SUCCESS = 'GET_WORKPLACE_ACTIVITYFEEDS_SUCCESS'
export const getWorkplaceActivityFeedsSuccess = (feeds) => (
    {
        type: GET_WORKPLACE_ACTIVITYFEEDS_SUCCESS,
        feeds: feeds ? feeds : []
    }
)

export const GET_WORKPLACE_ACTIVITYFEEDS_SUCCESS_INIT = 'GET_WORKPLACE_ACTIVITYFEEDS_SUCCESS_INIT'
export const getWorkplaceActivityFeedsSuccessInit = (feeds) => (
    {
        type: GET_WORKPLACE_ACTIVITYFEEDS_SUCCESS_INIT,
        feeds: feeds ? feeds : []
    }
)

export const GET_WORKPLACE_ACTIVITYFEEDS_FAILURE = 'GET_WORKPLACE_ACTIVITYFEEDS_FAILURE'
export const getWorkplaceActivityFeedsFailure = () => (
    {
        type: GET_WORKPLACE_ACTIVITYFEEDS_FAILURE
    }
)

export const attemptGetWorkplaceFeed = (workplaceId, isInit) => {
    return (dispatch, getState) => {
        var skip = isInit ? 0 : getState().workplaceFeedsReducer.feeds.length;
        var take = 20;
        var _url = process.env.REACT_APP_webApiEndPoint + 'api/workplace/'+workplaceId+'/feed?skip='+skip+'&take='+take;
        dispatch(getWorkplaceActivityFeedsRequest())
        return httpGet(_url)
        .then(response => {
            return response.json();
        })
        .then(json => {
            isInit ? dispatch(getWorkplaceActivityFeedsSuccessInit(json))
                    : dispatch(getWorkplaceActivityFeedsSuccess(json))
        })
        .catch(() => {
            dispatch(getWorkplaceActivityFeedsFailure())
            dispatch(addAlert("Kunne ikke hente aktivitetsfeed"))
        })
    };
}


// WEBPACK FOOTER //
// ./src/App/ShortTermProjects/Workplace/Overview/Feed/actions.js